import * as localizations from './localizations';

export const appTranslations: { [key: string]: { [key: string]: string } } = localizations;
